import React from 'react';
import ReactDOM from 'react-dom';
import marked from 'marked';
import Parser from 'html-react-parser';
import './index.css';
import './github-markdown.css';


class OutputMarkdown extends React.Component{
	render(){
		return(
			<div className='markdown-body'>
				{Parser(this.props.text)}
			</div>
		)
	}
}

class InputMarkdown extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			inputMark:'Heading\n=======\n\nSub-heading\n-----------\n \n### Another deeper heading\n \nParagraphs are separated\nby a blank line.\n\nLeave 2 spaces at the end of a line to do a  \nline break\n\nText attributes *italic*, **bold**, \n`monospace`, ~~strikethrough~~ .\n\nShopping list:\n\n  * apples\n  * oranges\n  * pears\n\nNumbered list:\n\n  1. apples\n  2. oranges\n  3. pears\n\nThe rain---not the reign---in\nSpain.\n\n *[Yordan Zhelev](https://yordanzhelevdev.github.io/)*',
		};
		this.handleChange = this.handleChange.bind(this);
	}
	handleChange(event){
		this.setState({inputMark: event.target.value});
	}

	render() {
		const input = this.state.inputMark;
		return (
			<div>
				<textarea rows="22" value={input} onChange={this.handleChange} />
				<OutputMarkdown text={(marked(input))}/>
			</div>
		);
	}
};


ReactDOM.render(
<InputMarkdown />,
document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/index.js